import React from 'react';
import moment from 'moment';
//Función principal
const QuickFilter = props => {
    //Tomo los props
    const { initialData, headers, setData } = props;
    //Manejo los cambios del filtro
    const handleChange = e => {
        //Me fijo si hay datos
        if(initialData && headers){
            //Filtro los resultados
            let newData = initialData.filter(item => {
                //Inicializo
                let itemFiltered = null;
                //Me fijo q exista
                if(item !== null){
                    let value = null;
                    //Tomo las cabeceras
                    headers.map(h => {
                        //Me fijo si es header válido
                        if(typeof h.actions === 'undefined' && item[h.field] != null){
                            //Asigno el valor
                            value = h.subfield ? item[h.field][h.subfield] : item[h.field];
                            //Me fijo si tengo que castear
                            if(typeof h.type !== 'undefined' && h.type === 'date'){
                                //Formateo
                                value = moment(value).format('DD/MM/YYYY');
                            }
                        }
                        //Realizo el filtro
                        if(String(value).toUpperCase().includes(String(e.target.value).toUpperCase())){
                            //Selecciono
                            itemFiltered = item;
                            //Retorno
                            return;
                        }
                    })
                }
                //Retorno
                return itemFiltered;
            })
            //Seteo la data
            setData(newData);
        }
    }
    //Renderizo
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-4">
                    <input 
                        type="text" 
                        placeholder="Ingrese texto" 
                        className="form-control" 
                        onChange={handleChange} 
                        autoFocus
                    />
                </div>
            </div>
            <hr/>
        </React.Fragment>
    );
};

export default QuickFilter;